class ProductSwatch extends HTMLElement {
    connectedCallback() {
        this._resizeSwatch();
        window.addEventListener('resize', this._resizeSwatch);
        this.querySelectorAll('.single-option-selector').forEach((e) => e.addEventListener('change', this._variantChange));

        if(this.querySelector('.single-option-selector[data-name="color"][checked]'))
            this.querySelector('.single-option-selector[data-name="color"][checked]').dispatchEvent(new CustomEvent('change', {detail: "no"}));
        else
            this.querySelector('.single-option-selector[checked]').dispatchEvent(new CustomEvent('change', {detail: "no"}));


    }
    constructor() {
        super();
        this._resizeSwatch = this._resizeSwatch.bind(this);
        this._variantChange = this._variantChange.bind(this);
        this._updateImages = this._updateImages.bind(this);
        this.btn = document.querySelector('#AddToCart');
        this.timer = null;
        this.notify = document.querySelector('notify-bar');
    }

    _variantChange(e){

        let variant = this._getVariantFromOptions();

        variant.parentElement.value = variant.value;
        this._updateImages(variant,e);
        this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.addToCart+'<span class="atc-savings" style="display: none;"></span>';


        if(e.detail!='no')
            this._updateHistoryState (variant);



        this.btn.removeAttribute('redirect');
        clearTimeout(this.timer);
        this.btn.removeEventListener('click',_addCartRedirects);



        if (!variant.disabled) {
            this.btn.classList.add('btn--sold-out');
            this.btn.disable = false;
            this.btn.removeAttribute('disabled');
            this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.addToCart+'<span class="atc-savings" style="display: none;"></span>';
            document.querySelector('.shopify-payment-button').classList.remove('hide');
        } else {
            this.btn.classList.remove('btn--sold-out');
            this.btn.disable = true;
            this.btn.setAttribute('disabled','');
            this.btn.querySelector('.btn-inside').innerHTML = window.productStrings.soldOut;
            document.querySelector('.shopify-payment-button').classList.add('hide');
        }

        this._updatePrice (variant);

        let options = [...this.querySelectorAll(`select option[disabled][data-option1="${variant.dataset['option1']}"]`)];


        if(options.length){
            let s = document.querySelector('.swatch-option.size');
            s.querySelectorAll('input').forEach((i)=>{
                i.parentElement.parentElement.classList.remove('disabled');
                i.removeAttribute('disabled');
                i.disabled = false;
            });
            if(s){
                options.forEach((c)=>{
                    let dd = s.querySelectorAll(`input[value="${c.dataset.option2}"]`);
                    dd.forEach((d)=>{
                        d.setAttribute('disabled','');
                        d.disabled = true;
                        d.parentElement.parentElement.classList.add('disabled');
                    });

                });
            }
        }
        let form = this.closest('form');
        if(form) {
            let err = form.querySelector('.swatch-option.size .size-error');
            if (form && err)
                err.style.display = 'none';
        }
    }

    _updateImages(variant,e) {

        let sl = document.querySelector('#image-wrapper .main-slider');
        if (typeof(sl.swiper) !== 'undefined') {

            if (variant && variant.getAttribute('data-featured-media') && (e.target.dataset.name == 'couleur' || e.target.dataset.name == 'color')) {

                let img_id = variant.getAttribute('data-featured-media-id');
                if(typeof (window.galTest) === 'undefined') {
                    let imgs = document.querySelector('.product-single-photo[data-image-id="'+img_id+'"]');
                    console.log(imgs);
                    // Suppose you have an element
                    const parent = imgs.parentNode;
                    const childrenArray = Array.prototype.slice.call(parent.children);
                    let index = childrenArray.indexOf(imgs);
                    if(index < 0)
                        index = 0;
                    if(window.PDPisVariantB === true && index ===1)
                        index = 0;
                        sl.swiper.slideTo(index );
                   // sl.swiper.slideTo(variant.getAttribute('data-featured-media') * 1 - 1);
                    return;
                }


                // switches featured image on first position
                let wrapper = sl.querySelector('.swiper-wrapper');
                let thumb_wrapper = document.querySelector('.product-thumbs-wrap .swiper-wrapper');
                let thumb_swiper = thumb_wrapper.closest('.swiper');
                let swiper = wrapper.closest('.swiper');

                let color = variant.dataset[e.target.dataset.index].trim().replace(/\s/,'-').replace(/\s/,'-').replace(/\s/,'-').toLowerCase().replace('/','-').replace('--','-').replace('--','-').replace('--','-');
               // let img_id = variant.getAttribute('data-featured-media-id');



                let slides = sl.querySelectorAll('.swiper-slide');
                let thumb_slides = thumb_wrapper.querySelectorAll('.swiper-slide');



                if(typeof (window.gallery_slides) === 'undefined')
                    window.gallery_slides = slides;

                if(typeof (window.thumb_slides) === 'undefined')
                    window.thumb_slides = thumb_slides;
                // revealing variant images
                thumb_wrapper.innerHTML = '';
                wrapper.innerHTML = '';
                window.gallery_slides.forEach((slide) => {
                    if (color === 'all' || slide.dataset.color === color || slide.dataset.color==='all') {
                        wrapper.insertAdjacentElement('beforeend',slide)
                        //slide.classList.remove('swiper-slide-hidden');

                    }
                });

                window.thumb_slides.forEach((slide) => {
                    if (color === 'all' || slide.dataset.color === color || slide.dataset.color==='all') {
                       // slide.classList.remove('swiper-slide-hidden');
                        thumb_wrapper.insertAdjacentElement('beforeend',slide)

                    }
                });

                wrapper.insertBefore(wrapper.querySelector("[data-image-id='"+img_id+"']"), wrapper.children[0]);
                thumb_wrapper.insertBefore(thumb_wrapper.querySelector("[data-image-id='"+img_id+"']"), thumb_wrapper.children[0]);

                sl.swiper.update();
                thumb_swiper.swiper.update();
                swiper.scrollTo(0,0);
                thumb_swiper.scrollTo(0,0);

                sl.swiper.update();
                thumb_swiper.swiper.update();
                sl.swiper.slideTo(0);
                thumb_swiper.swiper.slideTo(0);

                return false

            }
        } else
            setTimeout(()=>this._updateImages(variant, e), 100);
    }

    _resizeSwatch() {
        const options = this.querySelectorAll('.swatch-option.size .options');
        let width = 0;
        options.forEach((e) => {
            e.removeAttribute('style');
            if (e.offsetWidth > width) {
                width = e.offsetWidth;
            }
        });

        options.forEach((e) => {
            var mx = 100 / Math.floor(e.closest('.swatch-option').offsetWidth / width);
            e.style.flex = '0 0 ' + mx + '%';
            e.style.maxWidth = mx + '%'
        });
    }

    _getCurrentOptions() {
        let currentOptions = [...this.querySelectorAll('.single-option-selector')].map(
            function (element) {
                let type = element.getAttribute('type');
                let currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if (element.checked) {
                        currentOption.value = element.value;
                        currentOption.index = element.getAttribute('data-index');
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = element.value;
                    currentOption.index = element.getAttribute('data-index');
                    return currentOption;
                }
            }
        );

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = currentOptions.filter(x => !!x);
        return currentOptions;
    }

    _getVariantFromOptions () {
        const selectedValues = this._getCurrentOptions();
        let q = '';
        selectedValues.forEach( (e)=>{
            q += '[data-'+e.index+'="'+e.value+'"]';
        });

        return this.querySelector('select option'+q);
    }

    _updatePrice (variant) {

        let current = document.querySelectorAll('.product-info .price .current');
        current.forEach((e)=>{
            let old = e.parentElement.querySelector('.old');
            if(old == null)
                e.insertAdjacentHTML("afterend","<div class='old'></div>");
        });
        let olds = document.querySelectorAll('.product-info .price .old');
        if (variant) {
            let price = variant.getAttribute('data-price');
            let old_price = variant.getAttribute('data-compare_at_price');

            if(window.showDiscount && variant.getAttribute('data-discount-price'))
                price = variant.getAttribute('data-discount-price');
            if(window.showDiscount && variant.getAttribute('data-discount-compare_at_price'))
                old_price = variant.getAttribute('data-discount-compare_at_price');

            let percent = Math.abs(Math.round((price*100)/old_price - 100));
            let savings = old_price*1 - price*1;

            let high = document.querySelector('.badge-highlight');
            let atcS = document.querySelector('.atc-savings');
            if(atcS) {
                this.btn.setAttribute('data-percent',percent);
                atcS.innerHTML = '<span>|</span>'+window.saveWord+' ' + percent + '%';
            }

            if(high) {
                high.innerHTML = percent + '% off' + '&nbsp; | &nbsp;'+window.saveWord+' ' + document.local.formatMoney(savings, theme.moneyFormat);
            }

           /// variant.getAttribute('data-compare_at');
            let vars;
           // let sale =  document.querySelector('.sale-tag');
            if((vars = sessionStorage.getItem('price-test')) && variant.hasAttribute('data-price-1')){
                if(vars == 1){
                    price = variant.getAttribute('data-price-1');
                    old_price = variant.getAttribute('data-compare_at-1');
                }
                if(vars == 2){
                    price = variant.getAttribute('data-price-2');
                    old_price = variant.getAttribute('data-compare_at-2');
                }
            }

            let ap = document.querySelectorAll('.ap-price');
            if(ap.length) ap.forEach((e)=>e.innerHTML = document.local.formatMoney((price/4), theme.moneyFormat));
            let cc = document.querySelectorAll('.product-info .price .current');
            if(cc.length) cc.forEach((e)=>e.innerHTML = document.local.formatMoney(price, theme.moneyFormat));

            // Update and show the product's compare price if necessary
            olds.forEach((e)=>{
                if (old_price > price) {
                    e.innerHTML = document.local.formatMoney(old_price, theme.moneyFormat);
                    e.classList.remove('hide');
                } else {
                    e.classList.add('hide');
                    /*  if(sale)
                          sale.classList.add('hide');*/
                }
            })

        } else {
           // old.classList.add('hide');
        }
        /*    if(typeof (currencySwitcher)!=='undefined')
              currencySwitcher.ajaxrefresh();*/
    }

    _updateHistoryState (variant) {
        if (!history.replaceState || !variant) {
            return;
        }

        var newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            variant.value;
        window.history.replaceState({ path: newurl }, '', newurl);
    }



}

customElements.define('product-swatch',ProductSwatch);